import React, { useState, useEffect } from "react";
import { Drawer, Button, Form } from "antd";
import { DataStore } from '@reams/elias-store';
import { Asset } from "models";
import "styles/drawer.scss";
import SpacePicker from "./SpacePicker/SpacePicker";
import FormEditAlert from "components/FormEditAlert/FormEditAlert";
import { logUserEvent } from "helpers/userEventLogger";
import { useOnlineContext } from "helpers/contexts/OnlineContext/OnlineContext";
import { useEntityData } from "EntityDataContext/EntityDataContext";
import { isEqual } from "lodash";

export default function MoveAssetDrawer(props) {
  const { asset, onClose, visible, parents, complete} = props;

  const { user, spaces, userData: { email }, syncStatusHook: { imagesToUploadCount } } = useEntityData();

  const { isOnline } = useOnlineContext();

  const [form] = Form.useForm();

  const { space: currentSpace, facility } = parents;

  const [isLoading, setIsLoading] = useState(false);
  const [space, setSpace] = useState();
  const [isDirty, setIsDirty] = useState(false);
  const [defaultValues, setDefaultValues] = useState();

  useEffect(() => {
    setDefaultValues(space);
  }, [])

  useEffect(() => {
    if (isDirty) {
      scrollToBottom();
    }
  }, [ isDirty])

  function scrollToBottom() {
    const targetEle = document.querySelector(".form-alert-box");

    if (targetEle) {
      const formDrawerEle = targetEle.closest(".ant-drawer-body");

      if (formDrawerEle) {
        formDrawerEle.scrollTo({
          top: formDrawerEle.scrollHeight,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  }

  async function onSubmit() {
    const userEmail = user.idToken.payload.email;
    setIsLoading(true);
    if (asset && space) {
      const original = await DataStore.query(Asset, asset.id);
      const facets = JSON.stringify({
        ...original.facets,
      });

      const chosenSpace = spaces.items[space.key]

      await DataStore.save(
        Asset.copyOf(original, (updated) => {
          updated.updatedBy = userEmail;
          updated.spaceId = chosenSpace.id;
          updated.floorId = chosenSpace.floorId;
          updated.facilityId = chosenSpace.facilityId;
          updated.siteId = chosenSpace.siteId;
          updated.regionId = chosenSpace.regionId;
          updated.facets = facets;
        })
      );

      logUserEvent({
        user: email,
        eventType: `Move asset ${asset.id} via Move Asset drawer to Floor=${chosenSpace.floorId}, Space=${chosenSpace.id}`,
        imageOutboxSize: imagesToUploadCount
      }, isOnline);

      complete({ name: original.assetType.description, space: space.title });
    }

    onClose();
    setIsLoading(false);
  }

  function handleDrawerMaskClose() {
    const formUpdated = !isEqual(defaultValues, space);

    if (formUpdated) {
      setIsDirty(true);
    }
  }

  return (
    <Drawer
      title={`Move asset ${asset.assetType.description}`}
      placement="right"
      onClose={() => handleDrawerMaskClose()}
      visible={visible}
      className="move-asset-drawer"
      forceRender
      closable={false}
    >
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onSubmit}
        autoComplete="off"
        form={form}
      >
        <>
          <div className="form-group">
            <div className="checkbox-textarea-group">
              <SpacePicker
                onChange={setSpace}
                space={space}
                facility={facility}
                currentSpace={currentSpace}
                facilityLevel
              />
            </div>
          </div>
        </>
        {isDirty && (
          <FormEditAlert onClose={() => setIsDirty(false)} />
        )}
        <div className="form-buttons">
          <Button type="transparent" onClick={() => {
            logUserEvent({
              user: email,
              eventType: "Move asset drawer closed",
              imageOutboxSize: imagesToUploadCount
            }, isOnline);

            onClose()
          }}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={!space}
          >
            Save
          </Button>
        </div>
      </Form>
    </Drawer>
  );
}
